{
  "dismiss": "Απόρριψη"
}